import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import useId from '@indeed/ihl-use-id';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';

const ThemedInteractiveListGroup = /*#__PURE__*/themed("ul", process.env.NODE_ENV === "production" ? {
  target: "e1egzf5e0"
} : {
  target: "e1egzf5e0",
  label: "ThemedInteractiveListGroup"
})(() => ({
  margin: 0,
  padding: 0,
  textIndent: 0,
  listStyleType: "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const InteractiveListGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    header,
    ...remainingProps
  } = props;
  const headerId = `${useId()}-option-header-id`;
  return jsx(Box, {
    as: "li",
    sx: {
      display: "flex",
      flexDirection: "column",
      "&:not(:last-child)": {
        marginBlockEnd: 3
      }
    }
  }, jsx(ThemedInteractiveListGroup, _extends({
    ref: ref,
    "aria-labelledby": headerId
  }, remainingProps), jsx(Box, {
    as: "li",
    "aria-hidden": "true" // Hide so it doesn't announce as part of ul
    ,
    id: headerId,
    sx: {
      color: "foreground.strong",
      display: "flex",
      flexDirection: "column",
      fontSize: 2,
      fontWeight: "bold",
      paddingInlineStart: 3,
      paddingInlineEnd: 3,
      paddingBlockEnd: 2
    }
  }, header), children));
});
InteractiveListGroup.displayName = "InteractiveListGroup";

export { InteractiveListGroup };
